var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10788",
    "data-name": "Rectangle 10788",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(1.571 1.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M950.353,391.5a7.043,7.043,0,0,1,6.222,6.215",
    transform: "translate(-939.436 -391.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M950.353,395.043a3.912,3.912,0,0,1,3.093,3.093",
    transform: "translate(-939.436 -391.912)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M945.982,400.313c3.525,3.524,4.324-.552,6.569,1.691,2.164,2.163,3.409,2.6.667,5.338-.344.276-2.526,3.6-10.194-4.07s-4.35-9.852-4.074-10.2c2.749-2.748,3.175-1.5,5.339.665C946.532,395.986,942.457,396.788,945.982,400.313Z",
    transform: "translate(-938 -391.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.cad884b7757026a26d8222452858b5e5.svg";
export { ForwardRef as ReactComponent };